import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopDetailResponse } from '@/repositories/generated';

const response: ShopDetailResponse = {
  id: '00001',
  name: '○○○○ 渋谷店',
  externalShopId: 'shop01',
  shopCustomField1Regex: '^\\d*$', // 数字のみ
  shopCustomField2Regex: '^[0-9]{3}$', // 数字3桁
  shopCustomField3Regex: '^(^[^ -~｡-ﾟ]+)?$', // 全角文字のみ
  shopCustomField4Regex: '',
  shopCustomField5Regex: '',
  phone: '03-1234-5678',
  status: 'AVAILABLE',
  defaultShop: false,
  shopDetailBasicInfo: {
    shopCustomField1: 'ABC123',
    shopCustomField2: '１２３４５',
    shopCustomField3: 'テスト店舗',
    shopCustomField4: '',
    shopCustomField5: '',
    postalCode: '160-0022',
    prefecture: '東京都',
    municipalities: '渋谷区宇多川町三丁目 5-1',
    buildingName: '麹町ビル',
    dealerCode: '1234',
    shopStartDate: '2022-09-27T00:00:00+09:00',
    shopEndDate: '2030-09-27T00:00:00+09:00',
    companyResponse: {
      id: '010',
      name: '株式会社インフキュリオン',
    },
    createdAt: '2022-09-24T18:51:56+09:00',
    updatedAt: '2023-01-24T18:51:56+09:00',
    homepageUrl: 'http://www.○○○.com',
    latitude: 35.68914354752421,
    longitude: 139.6927675,
    externalIdUpdateAvailableFlg: true,
    // merchantCategoryCode: '00001',
    // nameKana: 'テストテンポ',
    // nameRomaji: 'TESUTOTENPO',
  },
  shopDetailQrInfo: {
    corporationId: '1111111111111111',
    brandId: '2222',
    contractStoreId: '333333',
  },
  shopDetailTransactionLimitInfo: {
    maxSettlementAmount: 10000,
  },
  shopDetailSettlementServiceInfos: [{
    walletServiceResponse: {
      id: '016',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 1,
    settlementService: 'MKP',
    paymentType: 'HOUSE_PREPAID',
    shopSettlementServiceStartDate: '2025-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-19T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '',
    pspGmoShopPassword: '',
    housePrepaidFeeRatio: '5',
    digitalVoucherFeeRatio: '2.5',
  },
  {
    walletServiceResponse: {
      id: '017',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 2,
    settlementService: 'MKP',
    paymentType: 'HOUSE_PREPAID',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '11111',
    pspGmoShopPassword: '12345',
    pspGmoCompUsageFlg: false,
    housePrepaidFeeRatio: '5',
    digitalVoucherFeeRatio: '0',
  },
  // {
  //   walletServiceResponse: {
  //     id: '017',
  //     name: '○○Pay',
  //   },
  //   walletServiceSettlementSettingId: 2,
  //   settlementService: 'PSP_GMO',
  //   paymentType: 'PREPAID',
  //   shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
  //   shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
  //   directBankFeeRatio: 1,
  //   prepaidSettlementFeeRatio: 2,
  //   prepaidChargeFeeRatio: 3,
  //   creditFeeRatio: 4,
  //   pspGmoShopId: '11111',
  //   pspGmoShopPassword: '12345',
  //   pspGmoCompUsageFlg: undefined,
  //   housePrepaidFeeRatio: 5,
  // },
  {
    walletServiceResponse: {
      id: '018',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 3,
    settlementService: 'PSP_DGFT',
    paymentType: 'PREPAID',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: undefined,
    pspGmoShopPassword: undefined,
    pspGmoCompUsageFlg: undefined,
    housePrepaidFeeRatio: '5',
  },
  {
    walletServiceResponse: {
      id: '019',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 4,
    settlementService: 'BANK_PAY',
    paymentType: 'PREPAID',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '',
    pspGmoShopPassword: '',
    housePrepaidFeeRatio: '5',
  },
  {
    walletServiceResponse: {
      id: '020',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 2,
    settlementService: 'PSP_GMO',
    paymentType: 'PREPAID',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '11111',
    pspGmoShopPassword: '12345',
    pspGmoCompUsageFlg: true,
    housePrepaidFeeRatio: '5',
  }],
  // 名称・IDは商品券事業autocompleteモック（src/mocks/api/autocomplete/gift-business.ts）と整合させている
  shopDetailGiftInfos: [
    {
      giftBusinessId: '1',
      giftBusinessName: '熊本市デジタル商品券',
      giftTicketId: '1',
      giftTicketName: '共通利用券',
    },
    {
      giftBusinessId: '4',
      giftBusinessName: '自由枠事業A',
      giftTicketId: '3',
      giftTicketName: '自由枠券面A',
    },
    {
      giftBusinessId: '7',
      giftBusinessName: 'ABI用商品券事業01',
      giftTicketId: '7',
      giftTicketName: 'ABI用商品券面01-01',
    },
  ],
  remarks: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
  regex: '^[0-9a-zA-Z]*$',
  shopDetailSmartCodeInfo: {
    nameKana: 'テストテンポ',
    nameRomaji: 'TESUTOTENPO',
    merchantCategoryCode: '00001',
    smartCodeStartsAt: '2023-01-01T00:00:00+09:00',
    smartCodeEndsAt: '2100-12-31T00:00:00+09:00',
  },
};

export const shopDetail = http.get(
  createMockEndpoint('/shop/:id'),
  async ({ params }) => {
    if (params.id === '000000002') {
      const nullResponse: ShopDetailResponse = {
        ...response,
        ...{
          shopDetailBasicInfo: {
            companyResponse: {
              id: '010',
              name: '株式会社インフキュリオン',
            },
            createdAt: '2022-09-24T18:51:56+09:00',
            updatedAt: '2023-01-24T18:51:56+09:00',
            externalIdUpdateAvailableFlg: true,
            merchantCategoryCode: '00001',
            nameKana: 'テストテンポ',
            nameRomaji: 'TESUTOTENPO',
          },
        },
      };

      return HttpResponse.json(nullResponse, { status: 200 });
    }
    await delay(500);

    return HttpResponse.json(response, { status: 200 });
  },
);
